// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2747e1be","453":"ab3442d0"}[chunkId] + ".chunk.js";
};